import * as React from 'react';

import type { ExternalCoachDisclosureProps } from 'bundles/ai-course-coach';

export const ExternalCoachDisclosure = React.lazy(() =>
  // FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
  // eslint-disable-next-line import/no-cycle
  import(/* webpackChunkName: "CourseraCoachBundle" */ 'bundles/ai-course-coach/index').then((module) => ({
    default: module.ExternalCoachDisclosure,
  }))
);

type LazyLoadedExternalCoachDisclosureProps = ExternalCoachDisclosureProps & {
  isCoachEnabled: boolean;
};

export function AiCourseraCoachExternalCoachDisclosureLazyLoad(props: LazyLoadedExternalCoachDisclosureProps) {
  return (
    <React.Suspense fallback={null}>{props.isCoachEnabled && <ExternalCoachDisclosure {...props} />}</React.Suspense>
  );
}
